import { CurveShape } from '@1x2network/particle_trail/lib/bezier/shapes/CurveShape'
import { BezierPointsTuple } from '@1x2network/particle_trail/lib/bezier/types'
import { Point } from 'pixi.js'
import { pixiMathUtils } from '@1x2network/utils_pixi_math'

const { rotatePoint } = pixiMathUtils

/**
 * Create a swoosh shape for a bezier curve (think like the Nike logo)
 * @author Adam Drake - <adam.drake@1x2network.com>
 * @version 1.0.0
 */
export class SwooshShape extends CurveShape {
    public calculateControlPoints(start: Point, end: Point): BezierPointsTuple {
        const difference = end.subtract(start)
        const distance = difference.magnitude()
        const direction = difference.normalize().multiplyScalar(-1)

        const curveSpread = this.getControlPointAngle(difference)
        const { startFactor, endFactor } = this.getDistanceFactor(distance)

        const startDirection = rotatePoint(direction, curveSpread)
        const c1 = start.add(startDirection.multiplyScalar(distance * startFactor))
        const c2 = end.subtract(startDirection.multiplyScalar(distance * endFactor))

        return [start, c1, c2, end]
    }
}
